/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { AuthService } from 'src/app/service/auth.service';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { ConfigService } from 'src/app/service/config.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import { resolveLogo } from 'src/app/shared/utils/branding.utils';

/**
 * This is the menu above the cockpit, it contain the logo, search, filter, theme, etc...
 */

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-menu-above',
  templateUrl: './menu-above.component.html',
  styleUrls: ['./menu-above.component.scss'],
})
export class MenuAboveComponent {
  project: string;
  params: any;
  logo: string;
  screenSize$ = this.breakpointService.screenSize$;

  /**
   * query parameters subscribe
   */
  constructor(
    private route: ActivatedRoute,
    public routing: RoutingService,
    private router: Router,
    public auth: AuthService,
    public featureFlagsService: FeatureFlagsService,
    public config: ConfigService,
    private breakpointService: BreakpointService,
  ) {
    this.project = this.config.appConfig.routing.project;
    this.logo = resolveLogo(
      this.featureFlagsService.featureFlags.logo || this.project,
    );
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });
  }

  /**
   * Click logo redirect
   */
  inLogo() {
    this.router.navigate(['/'], {
      queryParams: {
        id: null,
        score: null,
        time: this.params.score ? null : this.params.time,
        newstype: this.selectPortfolioNewsType(),
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  selectPortfolioNewsType() {
    if (
      this.params.newstype &&
      (this.params.newstype == 'Chronological' ||
        this.params.newstype == 'Relevant' ||
        this.params.newstype == 'Events' ||
        this.params.newstype == 'Stories')
    ) {
      return this.params.newstype;
    } else {
      return 'Chronological';
    }
  }
}
